import React from 'react';
import Link from '@amzn/awsui-components-console/link';
import {
  CUT_TICKET_URL,
  SLACK_CHANNEL_URL,
  STRIDER_WIKI_URL,
} from 'src/common/constants';
import styles from './FooterBar.module.scss';

/**
 * Shared footer bar rendered at the bottom of every page.
 * Displays navigation links, branding, and copyright.
 */
const FooterBar: React.FC = () => (
  <div className={styles.barWrapper}>
    <div className={styles.bar}>
      <span className={styles.links}>
        <Link
          href={STRIDER_WIKI_URL}
          external={true}
          color="inverted"
          fontSize="body-s"
        >
          Our wiki
        </Link>
        <Link
          href={SLACK_CHANNEL_URL}
          external={true}
          color="inverted"
          fontSize="body-s"
        >
          Our Slack channel
        </Link>
        <Link
          href={CUT_TICKET_URL}
          external={true}
          color="inverted"
          fontSize="body-s"
        >
          Cut a ticket to us
        </Link>
      </span>
      <span className={styles.branding}>
        LangHub &#8212; Built by Translation Services &#183; Powered by STRIDER
      </span>
      <span className={styles.copyright}>
        &#169; Amazon, Inc. or its affiliates. All rights reserved.
      </span>
    </div>
  </div>
);

export default FooterBar;
